import React from 'react';
import BaseGrid from 'components/atoms/base-grid';
import CallDashboardMetricsPageHeader from 'components/organisms/call-agents-dashboard/page-header';
import { QueuesMetrics } from 'roger-call-dashboard';

import s from './styles.module.scss';

const CallAgentsDashboardQueuesPage: React.FC = () => {
  return (
    <BaseGrid className={s.wrapper} rowGap={40}>
      <CallDashboardMetricsPageHeader />
      <QueuesMetrics />
    </BaseGrid>
  );
};

export default CallAgentsDashboardQueuesPage;
